module.exports = __webpack_public_path__ + "static/media/purple-chevron-down.b97999e7.svg";